import {
    colorForAgentId,
    configNameFromMetadata,
    stripThreadNameTimestamp
} from '@/lib/deepIntelligenceAvatar';

import type { IThread } from '@chainlit/react-client';

import { type Artifact, ArtifactShelf } from './ArtifactShelf';

interface Props {
    thread?: Pick<IThread, 'name' | 'createdAt' | 'metadata'>;
    artifacts: Artifact[];
}

export function runTitle(thread?: Pick<IThread, 'name'>): string {
    return thread?.name ? stripThreadNameTimestamp(thread.name) : 'Untitled run';
}

export function RunHeader({ thread, artifacts }: Props) {
    const title = runTitle(thread);
    const kickerColor = colorForAgentId(
        thread?.metadata?.config_id ??
            thread?.metadata?.managed_agent_id ??
            'deep-intelligence'
    );

    return (
        <>
            <div className="flex items-center gap-2 mb-3">
                <span
                    className="inline-block rounded-full size-2"
                    style={{ backgroundColor: kickerColor }}
                />
                <span
                    className="font-semibold text-sm uppercase"
                    style={{ color: kickerColor }}
                >
                    {configNameFromMetadata(thread?.metadata)}
                </span>
            </div>

            <h1 className="mb-4 font-medium text-4xl">{title}</h1>

            <div className="flex items-center gap-4 mb-5 pb-4 border-border border-b">
                <span className="text-muted-foreground text-base">
                    {thread ? new Date(thread.createdAt).toLocaleString() : ''}
                </span>
            </div>

            <ArtifactShelf artifacts={artifacts} articleTitle={title} />
        </>
    );
}
